import { styled } from 'styled-components'

import { Button } from '@blade/ui-kit'

export const ToggleButton = styled(Button)`
  &[data-active='true'] {
    background: var(--background-4);
    color: var(--appearance-inv-1);
    &:hover {
      background: var(--background-5);
    }
  }
  &[data-active='false'] {
    background: var(--background-3);
    color: var(--text-10);
    &:hover {
      background: var(--background-4);
    }
  }
`
